import 'css-chunk:src/app/containers/GuestHome/GuestHome.scss';export default {
  "GuestHome": "_GuestHome_168ms_1",
  "nav": "_nav_168ms_6",
  "content": "_content_168ms_9"
};